import apiHandler from "../core/apiHandler";

const inventoryInitialStockApi = apiHandler('inventory/initial-stock');
export default inventoryInitialStockApi;
